export default "__VITE_ASSET__BUYJ$TPf__"